// extracted by mini-css-extract-plugin
export var container = "_up-0";
export var table = "_up-2";
export var tableWrapper = "_up-1";